import React, { useEffect, useState } from "react";
import { useTheme } from "../../../../../hooks";
import { checkForActive } from "../../../../../utils";
import { getWindow } from "../../../../../utils/WindowUtil";
import { Icon } from "../../../../icon";
import CustomLink from "../../shared/link/CustomLink";
import { NavMenuCollapsable, NavMenuContainer, NavMenuLink } from "./NavMenuStyles";
const SubLinkContent = ({ subLink, subLinkActive, onClick }) => {
    const { Theme } = useTheme();
    const [hovered, setHovered] = useState(false);
    return (React.createElement(NavMenuLink, { active: subLinkActive, onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false), onClick: () => {
            if (!!onClick) {
                onClick();
            }
            if (!!subLink.onClick) {
                subLink.onClick();
            }
        } },
        !!subLink.icon && (React.createElement(Icon, { className: "me-2", iconName: subLink.icon, iconCategory: subLink.iconCategory, styles: {
                color: hovered
                    ? Theme.nav.mobile.hover.color
                    : subLinkActive
                        ? Theme.nav.mobile.active.color
                        : Theme.nav.mobile.menu.link.color,
                hoverColor: Theme.nav.mobile.hover.color,
            } })),
        subLink.name));
};
const NavMenu = ({ customLinkComponent, ...rest }) => {
    const { to, subLinks = [], name, icon, iconCategory, onClick } = rest;
    const { Theme } = useTheme();
    const location = getWindow()?.location;
    const [menuOpen, setMenuOpen] = useState(true);
    const [active, setActive] = useState(true);
    const [hovered, setHovered] = useState(false);
    const [visibleSubLinks, setVisibleSubLinks] = useState([]);
    useEffect(() => {
        const subTos = visibleSubLinks.filter((sl) => !!sl.to).map((sl) => sl.to);
        if (!!to?.length) {
            subTos.push(to);
        }
        setActive(checkForActive(location, ...subTos));
    }, [visibleSubLinks]);
    useEffect(() => {
        const visible = subLinks.filter((subLink) => subLink.visible !== false);
        setVisibleSubLinks(visible);
    }, [subLinks]);
    return (React.createElement(NavMenuContainer, null,
        React.createElement(NavMenuCollapsable, { active: active, onClick: () => setMenuOpen(!menuOpen), onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false) },
            !!icon && (React.createElement(Icon, { className: "me-2", iconName: icon, iconCategory: iconCategory, styles: {
                    color: hovered
                        ? Theme.nav.mobile.hover.color
                        : active
                            ? Theme.nav.mobile.active.color
                            : Theme.nav.mobile.menu.color,
                    hoverColor: Theme.nav.mobile.hover.color,
                } })),
            name,
            React.createElement("div", { className: "ms-auto" },
                React.createElement(Icon, { className: "", iconName: menuOpen ? "fa-angle-up" : "fa-angle-down", styles: {
                        color: hovered
                            ? Theme.nav.mobile.hover.color
                            : active
                                ? Theme.nav.mobile.active.color
                                : Theme.nav.mobile.menu.color,
                        hoverColor: Theme.nav.mobile.hover.color,
                    } }))),
        menuOpen &&
            visibleSubLinks.map((subLink) => {
                const subLinkActive = !!subLink.to ? checkForActive(location, subLink.to) : false;
                return !!subLink.to ? (React.createElement(CustomLink, { to: subLink.to, customLinkComponent: customLinkComponent, key: subLink.name },
                    React.createElement(SubLinkContent, { subLink: subLink, onClick: onClick, subLinkActive: subLinkActive }))) : (React.createElement(SubLinkContent, { key: subLink.name, subLink: subLink, onClick: onClick, subLinkActive: subLinkActive }));
            })));
};
export default NavMenu;
//# sourceMappingURL=NavMenu.js.map